import { render } from "./slide2.vue?vue&type=template&id=42e87e3f&scoped=true"
import script from "./slide2.vue?vue&type=script&lang=js"
export * from "./slide2.vue?vue&type=script&lang=js"

import "./slide2.vue?vue&type=style&index=0&id=42e87e3f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e87e3f"]])

export default __exports__